"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _dist = require("@low6dev/react-utils/dist");

var _ = require("../");

var _sharedInputStyles = require("./sharedInputStyles");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  justify-content: space-around;\n  padding: 0 0.5rem;\n  column-gap: 0.5rem;\n"])), _sharedInputStyles.wrapperStyles);

var StyledFlagImage = _styledComponents.default.img(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 32px;\n"])));

var StyledText = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (p) {
  return p.theme.colorText;
});

var StyledIcon = (0, _styledComponents.default)(_.MatIcon)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (p) {
  return p.theme.colorText;
});

var Wrapper = function Wrapper() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledWrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledFlagImage, {
      src: (0, _dist.createImageCdnLink)("flags/Netherlands.png")
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledText, {
      children: "+31"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIcon, {
      children: "keyboard_arrow_down"
    })]
  });
};

var _default = Wrapper;
exports.default = _default;